import * as React from "react";
import { useEffect, useState } from "react";
import userIcon from "../../../../../assets/images/icons/user1.png";
import mailIcon from "../../../../../assets/images/icons/mail.png";
import phoneIcon from "../../../../../assets/images/icons/phone.png";
import appIcon from "../../../../../assets/images/icons/whatsapp.png";
import warnIcon from "../../../../../assets/images/icons/warn.png";
import { Project } from "src/app/models";
import {
  getProject,
  getCorporates,
  createProject,
  updateProject,
  deleteProject,
  getUsersOfProject,
  getProjectSummary,
  getCorporate,
} from "src/services/corporateService";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useNavigate } from "src/app/authentication/login-react/PolarLogin";
import  authService  from "src/app/polar-SAAS-Components/auth-service";
import Loader from "src/app/polar-SAAS-Components/components/Loader";
import { AuthService } from "src/app/authentication/auth.service";
import {validateEmail,validatePhoneNumber} from 'src/app/polar-SAAS-Components/utilsNew';
import useStyleClasses from "src/app/polar-SAAS-Components/style";
import ConfirmationPopup from "src/app/polar-SAAS-Components/components/ConfirmationPopup";
import {clearQueryParam} from "src/app/polar-SAAS-Components/utilsNew"
import Toaster from "src/app/polar-SAAS-Components/components/Toaster";
import { useIsMobile } from "../../../../polar-SAAS-Components/utilsNew";


const Projects = (props) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [projects, setProjects] = useState<Project[]>([]);
  const [loading, setLoading] = useState(true);
  const [corporates, setCorporates] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editingProjectId, setEditingProjectId] = useState<string | null>(null);
  const [userCounts, setUserCounts] = useState<{ [projectId: string]: number }>(
    {}
  );
  const [formErrors, setFormErrors] = useState({
    contactPhone: "",
    contactEmail: ""
  });
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [projectToDelete, setProjectToDelete] = useState({ id: "", name: "" });

  const [openToaster,setopenToaster]=useState(false);
  const [msg,setMsg]=useState("");
  const [success,setSuccess]=useState(true);
  const styleClasses = useStyleClasses();

  const navigate = useNavigate();


  const history = useHistory();

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  const corporateId = query.get("corporateId");
  const isMobile = useIsMobile(768);
  

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        setLoading(true);
      if(authService.isCorporateAdmin()||authService.isCorporateSAASAdmin()){
        const res = await getCorporates();
        const data = res && res.content ? res.content : [];
        if(data.length==1){
          props.setCorporateName(data[0].name)
        }
      }
      else if(corporateId==null||undefined){
        props.setCorporateName(null)}
        let data = [];
        if (corporateId) {
          if (!props.corporateName) {
            const corps = await fetchCorporates();

            const currentCorp = corps.find(
              (corp) => corp.id === corporateId
            );

            if (currentCorp) {
              props.setCorporateName(currentCorp.name);
            }
          }
          try{
          const res = await getProject(corporateId);
          if(res.status=200){
          data = res && res.data.content ? res.data.content : [];
          }
          else {
            setMsg('Failed to get Corporate');
            clearQueryParam();
            setSuccess(false)
            setopenToaster(true);
            setTimeout(function () {
              setopenToaster(false);
            }, 5000);
          }}
          catch (err) {
            setMsg('Failed to get Corporate');
            clearQueryParam();
            setSuccess(false)
            setopenToaster(true);
            setTimeout(function () {
              setopenToaster(false);
            }, 5000);

          }
        }
        else{
          const res = await getProject();
          data = res && res.data.content ? res.data.content : [];
        }
        

        const enrichedProjects = await Promise.all(
          data.map(async (p: any) => {
            const kitsAvailable = Array.isArray(p.kits) ? p.kits.length : 0;
            let devicesNotWorking = 0;
            let totalDevices = 0;
            let noOfWorkingKits=0;

            try {
              const summary = await getProjectSummary(p.id);
              const content = summary && summary.content;
              devicesNotWorking =
                content && content.noOfOfflineKits != null
                  ? content.noOfOfflineKits
                  : 0;
                noOfWorkingKits =
                content && content.noOfWorkingKits != null
                  ? content.noOfWorkingKits
                  : 0;
                  
              totalDevices =
                content && content.noOfKits != null ? content.noOfKits : 0;
            } catch (err) {
              console.warn(`Failed to fetch summary for project ${p.id}`, err);
            }

            return {
              ...p,
              kitsAvailable,
              devicesNotWorking,
              totalDevices,
              noOfWorkingKits
            };
          })
        );
        if (isMounted) {
          setProjects(enrichedProjects as any[]);
        }

        const userCountMap: { [key: string]: number } = {};

        await Promise.all(
          enrichedProjects.map(async (project: any) => {
            try {
              const userRes = await getUsersOfProject(project.id);
              const users = userRes && userRes.content ? userRes.content : [];

              if (isMounted) {
                userCountMap[project.id] = users.length;
              }
            } catch (err) {
              console.warn(
                `Failed to fetch users for project ${project.id}`,
                err
              );
              if (isMounted) {
                userCountMap[project.id] = 0;
              }
            }
          })
        );

        if (isMounted) {
          setUserCounts(userCountMap);
        }
      } catch (err) {
        if (isMounted) console.error("Failed to load projects", err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [corporateId]);



  useEffect(() => {
    if (corporateId) {
      setFormData((prev) => ({ ...prev, selectedCorporate: corporateId }));
    }
  }, [corporateId]);

  const [formData, setFormData] = useState({
    selectedCorporate: "",
    corporateName: "",
    contactName: "",
    contactEmail: "",
    contactPhone: "",
    contactWhatsapp: "",
    countryCode: "+94",
    brc: "",
    contactAddress: "",
  });

  const filteredProjects = projects.filter((project) =>
    [
      project.name,
      project.contactName,
      project.contactEmail,
      project.contactPhoneNumber,
    ]
      .join(" ")
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const hasProjectDeletePermission=()=>{
    return (authService.isSuperAdmin()||authService.isCorporateSAASAdmin())&&!authService.isMobileSAASAdmin()
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSubmit = async () => {
    let isMounted = true;

    let emailValidation=validateEmail(formData.contactEmail);
    let phoneValidation=validatePhoneNumber(formData.contactPhone);
    if (!emailValidation.isValid ||!phoneValidation.isValid) {
      setFormErrors(prev => ({
        ...prev,
        contactEmail: emailValidation.message,
        contactPhone: phoneValidation.message
      }));
      return;

    }
    setLoading(true);

      const payload = {
        corporateId: authService.isAzureUser()?authService.getCorporateId():formData.selectedCorporate,
        name: formData.corporateName,
        contactName: formData.contactName,
        contactEmail: formData.contactEmail,
        contactPhoneNumber: formData.contactPhone,
        contactWhatsappNumber: `${formData.countryCode}${formData.contactWhatsapp}`,
      };

      if (isEditing && editingProjectId) {
            try {
        const response=await updateProject(editingProjectId, payload);
        const updatedProject = response && response.data && response.data.content?response.data.content : null;
        if (updatedProject ) {
          setProjects((prevProjects) =>
            prevProjects.map((proj) =>
              proj.id === editingProjectId ? {...proj,name:updatedProject.name,contactName:updatedProject.contactName,contactEmail:updatedProject.contactEmail,contactPhoneNumber:updatedProject.contactPhoneNumber,contactWhatsappNumber:updatedProject.contactWhatsappNumber} : proj
            )
          );
        }
      }
        catch(error){
          console.error(" Error updating project:", error);
          setLoading(false);
          return; 
        }
      } else {
        try {
          await createProject(payload);
          if (formData.selectedCorporate || corporateId) {
            const res = await getProject(formData.selectedCorporate || corporateId);
            const data = res && res.data.content ? res.data.content : [];
            setProjects(data);
          }
          else {
            const res = await getProject();
            const data = res && res.data.content ? res.data.content : [];
            setProjects(data);
          }


        } catch (error) {
          console.error(" Error creating project:", error);
          setLoading(false);
          return;
        }
    }
      if (!isMounted) return;
      setLoading(false);

     
      setShowModal(false);
      setIsEditing(false);
      setEditingProjectId(null);
      setFormData({
        selectedCorporate: corporateId || "",
        corporateName: "",
        contactName: "",
        contactEmail: "",
        contactPhone: "",
        contactWhatsapp:"",
        countryCode: "+94",
        brc: "",
        contactAddress: "",
      });
    
      

    return () => {
      isMounted = false;
    };
  };

  const handleCancel = () => {
    setShowModal(false);
    setFormData({
      selectedCorporate: "",
      corporateName: "",
      contactName: "",
      contactEmail: "",
      contactPhone: "",
      contactWhatsapp:"",
      countryCode: "+94",
      brc: "",
      contactAddress: "",
    });
  };

  const handleDelete = async () => {

    try {
      setLoading(true);
      await deleteProject(projectToDelete.id);


      const res = await getProject(formData.selectedCorporate || corporateId);
      const data = res && res.data.content ? res.data.content : [];

      setProjects(data);
      setLoading(false);
      setConfirmOpen(false);

      setActiveMenu(null);
    } catch (error) {
      console.error(" Failed to delete project:", error);
    }
  };
  
    const fetchCorporates = async () => {
      try {
        const res = await getCorporates();
        const data = res && res.content ? res.content : [];
        setCorporates(data);
        return data;

      } catch (error) {
        console.error(" Failed to fetch corporates", error);
      }
    };
  const handleOpenCreateProject = async () => {
    setLoading(true);
    const data=await fetchCorporates();
    if(authService.isCorporateAdmin()&&data.lendth==1){
      //only one corporate assigned to corporate admin
      setFormData({...formData,selectedCorporate:data[0]})
    }

    setShowModal(true);
    setIsEditing(false);
    setLoading(false);
  };

  const [activeMenu, setActiveMenu] = React.useState<string | null>(null);

  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (!target.closest(".menu-container")) {
        setActiveMenu(null);
      }
    };
    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <>
      <div className="container-react">
        <div className="page-title-container">
          <h2 className="page-title-react"> {props.corporateName ? ` ${props.corporateName}` : "All Corporates"} </h2>
        </div>
        <div className="header">
          <div className="search-filter-section">
            <div className="search-container-react">
              <input
                type="text"
                className="search-input-react"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <span className="search-icon-react">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.4733 13.5266L11.9999 11.0733C12.96 9.87621 13.4249 8.3568 13.2991 6.82747C13.1733 5.29814 12.4664 3.87512 11.3236 2.85103C10.1808 1.82694 8.68914 1.27961 7.15522 1.32158C5.62129 1.36356 4.16175 1.99164 3.0767 3.0767C1.99164 4.16175 1.36356 5.62129 1.32158 7.15522C1.27961 8.68914 1.82694 10.1808 2.85103 11.3236C3.87512 12.4664 5.29814 13.1733 6.82747 13.2991C8.3568 13.4249 9.87621 12.96 11.0733 11.9999L13.5266 14.4533C13.5886 14.5158 13.6623 14.5654 13.7436 14.5992C13.8248 14.633 13.9119 14.6505 13.9999 14.6505C14.0879 14.6505 14.1751 14.633 14.2563 14.5992C14.3376 14.5654 14.4113 14.5158 14.4733 14.4533C14.5934 14.329 14.6606 14.1628 14.6606 13.9899C14.6606 13.817 14.5934 13.6509 14.4733 13.5266ZM7.33327 11.9999C6.41029 11.9999 5.50804 11.7262 4.74061 11.2135C3.97318 10.7007 3.37504 9.97185 3.02183 9.11913C2.66862 8.2664 2.57621 7.32809 2.75627 6.42285C2.93634 5.5176 3.38079 4.68608 4.03344 4.03344C4.68608 3.38079 5.5176 2.93634 6.42285 2.75627C7.32809 2.57621 8.2664 2.66862 9.11913 3.02183C9.97185 3.37504 10.7007 3.97318 11.2135 4.74061C11.7262 5.50804 11.9999 6.41029 11.9999 7.33327C11.9999 8.57095 11.5083 9.75793 10.6331 10.6331C9.75793 11.5083 8.57095 11.9999 7.33327 11.9999Z"
                    fill="#324054"
                  />
                </svg>
              </span>
            </div>

            {/* <button className="filter-btn">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.6663 2H1.33301L6.66634 8.30667V12.6667L9.33301 14V8.30667L14.6663 2Z"
                  stroke="#324054"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Filter
            </button> */}
          </div>

          {AuthService.hasProjectCreationAccess()&&!authService.isMobileSAASAdmin()&&
          <button
            className="add-btn-dashboard"
            onClick={handleOpenCreateProject}
          >
            + {isMobile ? "" : "Add Projects"}
          </button>}
        </div>

        <div className="grid-container">
            {!loading&&filteredProjects.length===0 ? <div className="no-results">No projects available.</div> : (
          <div className="corporates-grid">
              {filteredProjects.map((project) => (
                <div key={project.id} className="corporate-card">
                  <div className="card-headers">
                    <h3 className="company-name">{project.name}</h3>
                    {authService.hasProjectManagementAccess()&&
                      <div className="menu-container">
                    <span
                      className="menu-dots"
                      onClick={(e) => {
                        e.stopPropagation();
                        setActiveMenu(
                          activeMenu === project.id ? null : project.id
                        );
                      }}
                    >
                      ⋮
                    </span>
                    {activeMenu === project.id && (
                      <div className="dropdown-menu">
                        <button
                          className="dropdown-item"
                          onClick={() => {
                            setEditingProjectId(project.id);
                            setFormData({
                              selectedCorporate: project.corporateId || "",
                              corporateName: project.name || "",
                              contactName: project.contactName || "",
                              contactEmail: project.contactEmail || "",
                              contactPhone: project.contactPhoneNumber || "",
                              countryCode: "+94",
                              contactWhatsapp: project.contactWhatsappNumber || "",
                              brc: "",
                              contactAddress: "",
                            });
                            setIsEditing(true);
                            setShowModal(true);
                            setActiveMenu(null);
                          }}
                        >
                          Edit
                        </button>
                        <button
                          className="dropdown-item"
                          onClick={() => {
                            navigate(`/notifications?projectId=${project.id}`);
                            setActiveMenu(null);
                          }}
                        >
                          Notifications
                        </button>
                        <button
                          className="dropdown-item"
                          onClick={() => {
                            const type = "project"; // or "kit" / "user" depending on context
                            navigate(`/configurations?type=${type}&id=${project.id}`);
                          }}
                        >
                          Settings
                        </button>
                       {hasProjectDeletePermission()&&
                        <button
                          className="dropdown-item delete"
                          onClick={() => {setProjectToDelete(project);setConfirmOpen(true);}}
                        >
                          Delete
                        </button>}
                      </div>
                    )}
                  </div>}
                </div>
                <div className="contact-info">
                  <div className="contact-item">
                    <div className="contact-icon">
                      <img
                        src={userIcon}
                        width="22"
                        height="22"
                        alt="User Icon"
                        className="contact-icon"
                        style={{
                          display: "inline-block",
                          verticalAlign: "middle",
                        }}
                      />
                    </div>
                    <span>{project.contactName}</span>
                  </div>
                  <div className="contact-item">
                    <div className="contact-icon">
                      <img
                        src={mailIcon}
                        width="22"
                        height="22"
                        alt="User Icon"
                        className="contact-icon"
                        style={{
                          display: "inline-block",
                          verticalAlign: "middle",
                        }}
                      />
                    </div>
                    <span>{project.contactEmail}</span>
                  </div>
                  <div className="contact-item">
                    <div className="contact-icon">
                      <img
                        src={phoneIcon}
                        width="22"
                        height="22"
                        alt="User Icon"
                        className="contact-icon"
                        style={{
                          display: "inline-block",
                          verticalAlign: "middle",
                        }}
                      />
                    </div>
                    <span>{project.contactPhoneNumber}</span>
                  </div>
                  <div className="contact-item">
                    <div className="contact-icon">
                      <img
                        src={appIcon}
                        width="22"
                        height="22"
                        alt="User Icon"
                        className="contact-icon"
                        style={{
                          display: "inline-block",
                          verticalAlign: "middle",
                        }}
                      />
                    </div>
                    <span>{project.contactWhatsappNumber}</span>
                  </div>
                </div>
                <div className="stats-row">
                  <span
                    style={{  cursor: authService.hasProjectManagementAccess()
                                ? "pointer"
                                : "not-allowed", color: "#007bff" }}
                    onClick={() =>{
                        if (!authService.hasProjectManagementAccess()) return;
                      history.push(`/user-settings?projectId=${project.id}`)}
                    }
                  >
                    {userCounts[project.id] || 0} Users Available
                  </span>
                  <span
                    style={{ cursor: "pointer", color: "#007bff" }}
                    onClick={() => {
                      history.push(`/kits?projectId=${project.id}`);
                    }}
                  >
                    {project.kits.length > 0 ? `${project.kits.length} Entities Available` : "No Entities Available"}
                  </span>
                </div>
                <div
                  className={`card-footer ${project.devicesNotWorking > 0 ? "" : "nowarn"}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    history.push(`/kits?projectId=${project.id}`);
                  }}
                >
                  {project.devicesNotWorking > 0 && (
                    <div className="warning-section  ">
                    <span className="warning-icon">
                      <img
                        src={warnIcon}
                        width="16"
                        height="16"
                        alt="Warn Icon"
                        className="contact-icon"
                        style={{
                          display: "inline-block",
                          verticalAlign: "middle",
                        }}
                      />
                    </span>
                    <span>{project.devicesNotWorking} devices not working  </span>
                    </div>)}
                     {project.devicesNotWorking == 0 &&project.totalDevices > 0 && project.noOfWorkingKits > 0&&
                      (
                    <span className="device-count">{project.noOfWorkingKits==project.totalDevices?"All ":""}{project.noOfWorkingKits} devices working  </span>
                    )}
                    <span className="device-count">
                    [{project.totalDevices > 0 ? `${project.totalDevices} devices` : "No devices"}]
                  </span>
                  </div>
                </div>
              ))}
          </div>)}
        
          <Loader isLoading={loading} fullScreen={true}/>
          <Toaster open={openToaster} isSuccess={success} msg={msg}/>
        </div>

        {showModal && (
          <div className="model-overlay" >
            <div className="model" onClick={(e) => e.stopPropagation()}>
              <div className="model-header">
                <h2 className="model-title">
                  {isEditing ? "EDIT PROJECT" : "ADD PROJECT"}
                </h2>
                <button className="close-btn" onClick={handleCancel}>
                  ×
                </button>
              </div>
              <div className="model-body">
                {!isEditing&&corporates&&corporates.length>0&&<div className="form-group">
                  <label className="form-labal">
                    Select Corporate <span className="required">*</span>
                  </label>
                  <select
                    className="form-input"
                    name="selectedCorporate"
                    value={formData.selectedCorporate}
                    onChange={handleInputChange}
                  >
                    <option value="">-- Select --</option>
                    {corporates.map((corp) => (
                      <option key={corp.id} value={corp.id}>
                        {corp.name}
                      </option>
                    ))}
                  </select>
                </div>}

                <div className="form-group">
                  <label className="form-labal">
                    Project Name <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-input"
                    placeholder="Enter project name here"
                    name="corporateName"
                    value={formData.corporateName}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="form-group">
                  <label className="form-labal">
                    Contact Name <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-input"
                    placeholder="Enter contact name here"
                    name="contactName"
                    value={formData.contactName}
                    onChange={handleInputChange}
                  />
                </div>

                 <div className="form-row">
                <div className="form-group half">
                  <label className="form-labal">
                    Mobile <span className="required">*</span>
                  </label>
                  <input
                    type="tel"
                    className="form-input"
                    placeholder="eg: +94 xx xx xx"
                    name="contactPhone"
                    value={formData.contactPhone}
                    onChange={handleInputChange}
                  />
                   {formErrors.contactPhone.length > 0 && (
                      <span style={styleClasses.errorText}>
                        {formErrors.contactPhone}
                      </span>
                    )}
                </div>

                <div className="form-row half">
                  <div className="form-group code-input">
                    <label className="form-labal">
                      WhatsApp No. <span className="required">*</span>
                    </label>
                    <div className="phone-input-group">
                      <select
                        className="form-input country-code-select"
                        name="countryCode"
                        value={formData.countryCode}
                        onChange={handleInputChange}
                      >
                        <option value="+94">+94 (Sri Lanka)</option>
                        <option value="+91">+91 (India)</option>
                        <option value="+1">+1 (USA)</option>
                      </select>
                      <input
                        type="tel"
                        className="form-input"
                        placeholder="eg: 7x xx xx xxx"
                        name="contactWhatsapp"
                        value={formData.contactWhatsapp}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                </div>
                </div>

                <div className="form-group">
                  <label className="form-labal">
                    Contact Email <span className="required">*</span>
                  </label>
                  <input
                    type="email"
                    className="form-input"
                    placeholder="example@gmail.com"
                    name="contactEmail"
                    value={formData.contactEmail}
                    onChange={handleInputChange}
                  />
                   {formErrors.contactEmail && (
                      <span style={styleClasses.errorText}>
                        {formErrors.contactEmail}
                      </span>
                    )}
                </div>
              </div>
              <div className="model-footer">
                <button className="ktn btn-secondary" onClick={handleCancel}>
                  Cancel
                </button>
                <button className="ktn btn-primary" onClick={handleSubmit}>
                  {isEditing ? "Update Project" : "Create Project"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      <ConfirmationPopup
        open={confirmOpen}
        message={`Are you sure you want to delete this Kit - ${projectToDelete.name}?`}
        confirmText="Delete"
        cancelText="Cancel"
        onConfirm={handleDelete}
        onCancel={() => setConfirmOpen(false)}
        isDanger={true} />
    </>
  );
};

export default Projects;
